import styled from 'styled-components';

export const GreetingContainer = styled.div`
  margin-right: 25vw;
  font-size: 5vmin;
`;